import { toast } from 'react-toastify';
import { call, put, takeEvery } from 'redux-saga/effects';
import store from 'redux/store';
import {
  GET_RESERVATIONLIST,
  GET_ADDRESERVATION,
  GET_UPDATERESERVATION,
  GET_RESERVATIONDETAILS,
  GET_BOOKINGREPORTDOWNLOAD,
  GET_CANCELREASON,
  GET_BOOKINGBUFFERTIME,
  GET_AIRPORTTERMINALLIST,
} from 'resources/actionTypes';
import {
  getReservationListService,
  addReservation,
  updateReservation,
  getReservationDetailsService,
  getCancelReasonService,
  getBookingBufferTimeService,
  getAirportTerminalListService,
} from 'services/Reservation';
import {
  getReservationList,
  getReservationDetails,
} from 'redux/actions/reservationAction';
import { onLoaderTrigger } from 'redux/actions/commonAction';

function* getDocumentExport(action) {
  const payload = action.payload || {};
  const bokingListExport = yield call(getReservationListService, payload);
  if (bokingListExport.success) {
    yield put({
      type: GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_SUCCESS,
    });
    if(payload?.export){
      toast.success(bokingListExport.message);
    }
  } else {
    yield put({
      type: GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_FAILED,
      message: bokingListExport.message,
    });
    toast.error(bokingListExport?.message || 'Fetching Document list Failed');
  }
}

export function* getDocumentExportWatcher() {
  yield takeEvery(
    GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_REQUESTED,
    getDocumentExport
  );
}

function* fetchGetReservationList(action) {
  const payload = action.payload || {};
  const reservationList = yield call(getReservationListService, payload);
  if (reservationList.success) {
    yield put({
      type: GET_RESERVATIONLIST.GET_RESERVATIONLIST_SUCCESS,
      reservationList: reservationList,
    });
  } else {
    yield put({
      type: GET_RESERVATIONLIST.GET_RESERVATIONLIST_FAILED,
      message: reservationList.message,
    });
    toast.error(reservationList?.message || 'Fetching Reservation list Failed');
  }
}

export function* getReservationListWatcher() {
  yield takeEvery(
    GET_RESERVATIONLIST.GET_RESERVATIONLIST_REQUESTED,
    fetchGetReservationList
  );
}

function* fetchGetReservationDetails(action) {
  const payload = action.payload || {};
  const reservationDetails = yield call(getReservationDetailsService, payload);
  if (reservationDetails.success) {
    yield put({
      type: GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_SUCCESS,
      reservationDetails: reservationDetails,
    });
  } else {
    yield put({
      type: GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_FAILED,
      message: reservationDetails.message,
    });
    toast.error(reservationDetails?.message || 'Fetching Reservation details Failed');
  }
}

export function* getReservationDetailsWatcher() {
  yield takeEvery(
    GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_REQUESTED,
    fetchGetReservationDetails
  );
}

function* fetchAddReservation(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const addReservationList = yield call(
    addReservation,
    payload.reservationData
  );

  if (addReservationList.success) {
    yield put({
      type: GET_ADDRESERVATION.GET_ADDRESERVATION_SUCCESS,
      addReservationList: addReservationList,
    });
    toast.success(addReservationList.message);
    payload.setConfirmModal();
    store.dispatch(onLoaderTrigger(false));
  } else {
    yield put({
      type: GET_ADDRESERVATION.GET_ADDRESERVATION_FAILED,
      message: addReservationList.message,
    });
    toast.error(addReservationList?.message || 'Adding Reservation Failed');
    store.dispatch(onLoaderTrigger(false));
  }
}

export function* addReservationSaga() {
  yield takeEvery(
    GET_ADDRESERVATION.GET_ADDRESERVATION_REQUESTED,
    fetchAddReservation
  );
}

//Update Reservation
function* updateReservationSaga(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const updateReservationData = yield call(
    updateReservation,
    payload?.updateReservationData,
    payload?.id
  );
  if (updateReservationData.success) {
    yield put({
      type: GET_UPDATERESERVATION.GET_UPDATERESERVATION_SUCCESS,
      updateReservationData: updateReservationData,
    });
    toast.success(
      updateReservationData?.message || 'Updating Reservation Successfully'
    );
    store.dispatch(onLoaderTrigger(false));
    if (payload?.navigate === 'listPage') {
      store.dispatch(getReservationList({ pageSize: 10 }));
    } else if (payload?.navigate === 'details') {
      store.dispatch(getReservationDetails(payload?.updateReservationData?.id));
    } else {
      payload.navigate(`/reservation`);
    }
  } else {
    yield put({
      type: GET_UPDATERESERVATION.GET_UPDATERESERVATION_FAILED,
      message: updateReservationData.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(updateReservationData?.message || 'Updating Reservation failed');
  }
}

export function* onUpdateReservationWatcher() {
  yield takeEvery(
    GET_UPDATERESERVATION.GET_UPDATERESERVATION_REQUESTED,
    updateReservationSaga
  );
}

function* fetchGetCancelReason(action) {
  const payload = action.payload || {};
  const cancelReason = yield call(getCancelReasonService, payload);
  if (cancelReason.success) {
    yield put({
      type: GET_CANCELREASON.GET_CANCELREASON_SUCCESS,
      cancelReason: cancelReason,
    });
  } else {
    yield put({
      type: GET_CANCELREASON.GET_CANCELREASON_FAILED,
      message: cancelReason.message,
    });
    toast.error(cancelReason?.message || 'Fetching Cancel Reason Failed');
  }
}

export function* getCancelReasonWatcher() {
  yield takeEvery(
    GET_CANCELREASON.GET_CANCELREASON_REQUESTED,
    fetchGetCancelReason
  );
}

//get pre booking buffer time
function* getBookingBufferTime(action) {
  const payload = action.payload || {};
  const bufferTime = yield call(getBookingBufferTimeService, payload);
  if (bufferTime.success) {
    yield put({
      type: GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_SUCCESS,
      bufferTime: bufferTime,
    });
  } else {
    yield put({
      type: GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_FAILED,
      message: bufferTime.message,
    });
    toast.error(bufferTime?.message || "Fetching Booking Buffer Time Failed");
  }
}

export function* getBookingBufferTimeWatcher() {
  yield takeEvery(
    GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_REQUESTED,
    getBookingBufferTime
  );
}

//get airport Terminal list
function* getAirportTerminalList(action) {
  const payload = action.payload || {};
  const airportListDetails = yield call(getAirportTerminalListService, payload);
  if (airportListDetails.success) {
    yield put({
      type: GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_SUCCESS,
      airportTerminalsDetails: airportListDetails,
    });
  } else {
    yield put({
      type: GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_FAILED,
      message: airportListDetails.message,
    });
    toast.error(airportListDetails?.message || "Fetching Buffer Time Failed");
  }
}

export function* getAirportTerminalListWatcher() {
  yield takeEvery(
    GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_REQUESTED,
    getAirportTerminalList
  );
}